export const loader_style = {
  rootSx: {
    textAlign: 'center',
    p: 3,
    position: 'relative', 
    display: 'inline-flex' ,
  },
};
